// Stok kartı bölümlerinin ortak küçük parçaları.
import React from 'react';
import { Box, Button, FormControl, InputAdornment, MenuItem, Select, TextField, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import type { StockCardForm } from '../useStockCardForm';

export const SectionTitle: React.FC<{ title: string; hint?: string }> = ({ title, hint }) => (
  <Box sx={{ mb: 1.5 }}>
    <Typography variant="subtitle1" fontWeight={700}>{title}</Typography>
    {hint && <Typography variant="body2" color="text.secondary">{hint}</Typography>}
  </Box>
);

export const GroupLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography
    variant="overline"
    color="text.secondary"
    sx={{ display: 'block', lineHeight: 1.6, mt: 1.5, mb: 0.5, letterSpacing: '0.06em' }}
  >
    {children}
  </Typography>
);

export const AddLink: React.FC<{ label: string; onClick: () => void; disabled?: boolean }> = ({ label, onClick, disabled }) => (
  <Button size="small" startIcon={<AddIcon fontSize="small" />} onClick={onClick} disabled={disabled} sx={{ px: 0.5 }}>
    {label}
  </Button>
);

interface MoneyFieldProps {
  f: StockCardForm;
  id: string;
  label: string;
  value: number | '';
  onChange: (value: number | '') => void;
  currency: string;
  onCurrencyChange: (code: string) => void;
  required?: boolean;
  error?: boolean;
  helperText?: string;
}

/** Fiyat + para birimi. Boş = ''. */
export const MoneyField: React.FC<MoneyFieldProps> = ({
  f, id, label, value, onChange, currency, onCurrencyChange, required, error, helperText
}) => (
  <TextField
    id={id}
    fullWidth
    size="small"
    type="number"
    required={required}
    error={error}
    helperText={helperText}
    label={label}
    value={value}
    onChange={(e) => onChange(e.target.value === '' ? '' : Number(e.target.value))}
    inputProps={{ min: 0, step: '0.01' }}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <FormControl variant="standard" sx={{ minWidth: 56 }}>
            <Select
              value={currency}
              onChange={(e) => onCurrencyChange(String(e.target.value))}
              inputProps={{ 'aria-label': `${label} para birimi` }}
            >
              {f.availableCurrencies.filter(c => c.active).map(c => (
                <MenuItem key={c.code} value={c.code}>{f.getCurrencySymbol(c.code)}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </InputAdornment>
      ),
    }}
  />
);

/** Sayısal alan: boş '' döner. */
export const toNumberOrEmpty = (raw: string): number | '' => (raw === '' ? '' : Number(raw));
